
import type { CallLiveEvidence } from './GovernorCallLiveEvidence';

export function buildCallRepairRoutes(e: CallLiveEvidence) {
  const routes: any[] = [];

  if (!e.bridgeConnected) {
    routes.push({
      id: 'repair-call-bridge-evidence',
      title: 'Call bridge has no live evidence',
      subsystem: 'Calls',
      status: 'ready',
      priority: 'critical',
      reason: 'Incoming call bridge is not proving live session connection.',
      suggestedFix: 'Connect IncomingCallRuntimeBridge to call session creation/listener evidence and record bridgeConnected=true.',
    });
  }

  if (!e.pushHealthy) {
    routes.push({
      id: 'repair-call-push-health',
      title: 'Call push notification health is not proven',
      subsystem: 'Calls',
      status: 'ready',
      priority: 'critical',
      reason: 'Push delivery is not reporting healthy evidence.',
      suggestedFix: 'Verify Firebase token, push insert/send path, Android notification channel, and foreground service delivery.',
    });
  }

  if (!e.firebaseTokenPresent) {
    routes.push({
      id: 'repair-firebase-token',
      title: 'Firebase token missing from call evidence',
      subsystem: 'Calls',
      status: 'ready',
      priority: 'critical',
      reason: 'Governor cannot see an FCM token for the receiving device.',
      suggestedFix: 'Refresh and persist FCM registration token for the signed-in receiver.',
    });
  }

  if (!e.notificationChannelReady) {
    routes.push({
      id: 'repair-android-call-channel',
      title: 'Android call notification channel not proven',
      subsystem: 'Calls',
      status: 'ready',
      priority: 'critical',
      reason: 'Governor cannot verify the Android incoming-call notification channel.',
      suggestedFix: 'Verify/create incoming_call notification channel with heads-up importance.',
    });
  }

  if (!e.incomingServiceReady) {
    routes.push({
      id: 'repair-incoming-call-service',
      title: 'Incoming call service not proven',
      subsystem: 'Calls',
      status: 'ready',
      priority: 'critical',
      reason: 'Governor cannot verify IncomingCallService registration/readiness.',
      suggestedFix: 'Verify AndroidManifest service registration and foreground service permission path.',
    });
  }

  return routes;
}
